export default __webpack_public_path__ + "static/media/round-table.3b7c98c3.svg";